<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
  import vhead from '../../common/Head';
    export default{
        data(){
            return{


            }
        },
        ready:function(){



        },
        methods:{

        },
        components: {
          vhead
        }
    }
</script>



// WEBPACK FOOTER //
// index.vue?375d8bf0